module.exports = __webpack_public_path__ + "img/56.6928bfc9.png";